module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增套藥")]), (_vm.createForm) ? _c('CreateSpecialMedicineForm', {
    attrs: {
      "medicineType": 'combo'
    },
    on: {
      "closeForm": _vm.closeForm,
      "dataCreated": _vm.dataCreated
    }
  }) : _vm._e()], 1), _c('vuetable', {
    ref: "vuetableCombo",
    attrs: {
      "track-by": 'id',
      "api-mode": false,
      "fields": _vm.comboField,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "detail-row-component": "combo-detail",
      "item-actions": "itemActions"
    },
    on: {
      "vuetable:cell-clicked": _vm.onComboClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteCombo(props.rowData)
            }
          }
        }, [_vm._v("刪除套藥")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5a30b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/ComboSettings.vue
// module id = 1469
// module chunks = 1